import React from "react";
import PropTypes from "prop-types";
import { easilGrayXDark } from "./style.module.css";

const TemplateIcon = ({
  noPointer,
  className,
  width,
  size,
  height,
  style,
  color,
  title
}) => (
  <svg
    className={className}
    style={style}
    data-no-pointer={noPointer}
    width={width || size || 24}
    height={height || size || 24}
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby="title"
  >
    <title>{title}</title>
    <g fill="none" fillRule="evenodd">
      <path d="M-4-4h24v24H-4z" />
      <path d="M0 0h16v16H0z" />
      <path
        fill={color || easilGrayXDark}
        fillRule="nonzero"
        d="M3 2a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H3zm0-2h7a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3z"
      />
      <path
        fill={color || easilGrayXDark}
        fillRule="nonzero"
        d="M12.006 6a1 1 0 0 1 0-2h1.274C14.936 4 16 5.319 16 7v6c0 1.681-1.064 3-2.72 3h-2.784a1 1 0 0 1 0-2h2.784c.446 0 .72-.34.72-1V7c0-.66-.274-1-.72-1h-1.274zM5.705 8.65L7.75 6.337A1 1 0 0 1 9.25 7.663l-2.655 3a1 1 0 0 1-1.345.14l-1.346-1a1 1 0 0 1 1.194-1.606l.608.453z"
      />
    </g>
  </svg>
);
TemplateIcon.propTypes = {
  className: PropTypes.string,
  width: PropTypes.string,
  size: PropTypes.string,
  height: PropTypes.string,
  style: PropTypes.object,
  color: PropTypes.string
};

export default TemplateIcon;
